import React from "react"
import types from "prop-types"
import { TaskReportExportContextProvider } from "contexts/TaskReportExportContext"
import { formSlugOptionShape, newTaskReportExportTaskReportShape } from "utils/propTypeShapes"
import NewTaskReportExportForm from "./NewTaskReportExportForm"
import NewTaskReportExportProcessingCheck from "./NewTaskReportExportProcessingCheck"

const NewTaskReportExport = ({ submittableForms, taskReport }) => (
  <TaskReportExportContextProvider submittableForms={submittableForms} taskReport={taskReport}>
    <NewTaskReportExportForm />
    <NewTaskReportExportProcessingCheck />
  </TaskReportExportContextProvider>
)

NewTaskReportExport.propTypes = {
  submittableForms: types.arrayOf(formSlugOptionShape).isRequired,
  taskReport: newTaskReportExportTaskReportShape.isRequired,
}

export default NewTaskReportExport
